__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-10-15-1792059137-stable-dev/";